import React from 'react';
import './style.scss';
var Hamburger = function Hamburger(_ref) {
  var onClick = _ref.onClick,
    numberOfLines = _ref.numberOfLines,
    showMenuLabel = _ref.showMenuLabel;
  return /*#__PURE__*/React.createElement("div", {
    className: "Hamburger",
    onClick: onClick
  }, showMenuLabel && /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, "Menu"), /*#__PURE__*/React.createElement("div", {
    className: "hamburger-menu"
  }, Array.from({
    length: numberOfLines
  }).map(function (item, index) {
    return /*#__PURE__*/React.createElement("span", {
      key: index
    });
  })));
};
Hamburger.defaultProps = {
  onClick: function onClick() {},
  numberOfLines: 3,
  showMenuLabel: true
};
export default Hamburger;